<template>
  <base-page-teaching-feed mode="reviewer" />
</template>

<script>
import BasePageTeachingFeed from '../Feed/BasePageTeachingFeed';

export default {
  components: {
    BasePageTeachingFeed
  }
};
</script>
